module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('a', {
    attrs: {
      "id": "f0002-01"
    }
  }), _c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0002-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "brown1"
  }, [_vm._v("Captain Will Wright of the Texas Rangers cooks his dinner over a campfire (circa 1930).")])]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_txt"
  }, [_c('span', {
    staticClass: "brown1"
  }, [_c('em', [_vm._v("Photo: Texas State Library Archives Division")])])]), _vm._v(" "), _c('div', {
    staticClass: "wrap"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('a', {
    attrs: {
      "id": "f0004-01"
    }
  }), _c('img', {
    staticClass: "horizontal",
    attrs: {
      "alt": "image",
      "src": "images/f0004-01.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('span', {
    staticClass: "brown1"
  }, [_vm._v("A barbecue stand made of corrugated tin, Corpus Christi, 1939.")])]), _vm._v(" "), _c('p', {
    staticClass: "caption_1_txt"
  }, [_c('span', {
    staticClass: "brown1"
  }, [_c('em', [_vm._v("Photo by Russell Lee")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6b53814","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02front.vue
// module id = 57
// module chunks = 0